import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./auth";
import { AppShell } from "./components/AppShell";
import { AuthPage } from "./pages/AuthPage";
import { DashboardPage } from "./pages/DashboardPage";
import { PlannerPage } from "./pages/PlannerPage";
import { TravelPage } from "./pages/TravelPage";
import { FrenchPage, WordsPage } from "./pages/WordsPage";
import { NewsPage } from "./pages/NewsPage";
import { SettingsPage } from "./pages/SettingsPage";
import { AdminPage } from "./pages/AdminPage";
import { LearningPage } from "./pages/LearningPage";
import { FeedbackProvider } from "./feedback";

export function App() {
  const { status, loading } = useAuth();
  if (loading)
    return (
      <div className="splash">
        <div className="splash-orb">P</div>
        <p>正在准备你的生活工作台…</p>
      </div>
    );
  if (!status?.user)
    return <AuthPage needsSetup={Boolean(status?.needsSetup)} />;
  return (
    <FeedbackProvider>
      <AppShell user={status.user}>
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/planner" element={<PlannerPage />} />
          <Route path="/travel" element={<TravelPage />} />
          <Route path="/learning" element={<LearningPage />} />
          <Route path="/words" element={<WordsPage />} />
          <Route path="/french" element={<FrenchPage />} />
          <Route
            path="/ielts"
            element={<Navigate to="/words?track=ielts" replace />}
          />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route
            path="/admin"
            element={
              status.user.role === "admin" ? (
                <AdminPage />
              ) : (
                <Navigate to="/" replace />
              )
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AppShell>
    </FeedbackProvider>
  );
}
